import { Box, CssBaseline, Divider } from '@mui/material';
import { Helmet } from 'react-helmet';
import AppAppBar from '../landing/AppAppBar';
import Footer from '../landing/Footer';
import SocialTags from '../SocialTags';
import Policy from './Policy';

export default function Privacy() {
  return (
    <div>
      <Helmet>
        <title>
          ReachAI - Business Automation. Build Leads, Get digital powered websites and marketing
          your businesses - Privacy
        </title>
        <meta
          name="description"
          content="Welcome to ReachAI. Build Leads, Get digital powered websites and marketing your businesses "></meta>
        <meta
          name="keywords"
          content="website development in Cypress, website development in Houston, SEO,website development in Texas,website development near Cypress, website development near 77429, mobile app development near Cypress, android app development near Cypress, ios app development near Cypress, software development, custom software, software solutions, software company, software development company, software developer, software development services, software development agency, software development firm, Digital powered websites, marketing my businesses, reachai, Digital powered websites, marketing my businesses, reachai, ESSL"
        />
        <SocialTags />
      </Helmet>
      <main>
        <CssBaseline />
        <AppAppBar />
        <Box>
          <Divider />
          <Policy />
          <Footer />
        </Box>
      </main>
    </div>
  );
}
